export default class UpdateAssetImageModel {
    organizationId = null;
    assetId = null;
    base64Image = null;
    fileExtension = null;

    constructor(organizationId, assetId, base64Image, fileExtension){
        this.organizationId = organizationId;
        this.assetId = assetId;
        this.base64Image = base64Image;
        this.fileExtension = fileExtension;
    }
}